import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=4aed23ee&scoped=true&"
import script from "./Organization.vue?vue&type=script&lang=js&"
export * from "./Organization.vue?vue&type=script&lang=js&"
import style0 from "./Organization.vue?vue&type=style&index=0&id=4aed23ee&lang=scss&scoped=true&"
import style1 from "./Organization.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed23ee",
  null
  
)

export default component.exports